import { Point } from './point';
export class CornerSite {
    constructor() {
        // the coeffiecient used to calculate the first and the second control points of the
        // Bezier segment for the fillet at the site
        this.previouisBezierCoefficient = 0.5;
        // the coeffiecient used to calculate the third and the fourth control points of the
        // Bezier segment for the fillet at the site
        this.nextBezierCoefficient = 0.5;
        // the coefficient tells how tight the segment fits to the segment after the site; the formula is kNext * c + (1 - kNext) * b
        this.previousTangentCoefficient = 1.0 / 3;
        this.nextTangentCoefficient = 1.0 / 3;
    }
    static mkSiteP(sitePoint) {
        const s = new CornerSite();
        s.point = sitePoint;
        return s;
    }
    static mkSiteSP(previousSite, sitePoint) {
        const s = new CornerSite();
        s.point = sitePoint;
        s.prev = previousSite;
        previousSite.next = s;
        return s;
    }
    static mkSiteSPS(previousSite, sitePoint, nextSite) {
        const s = new CornerSite();
        s.prev = previousSite;
        s.point = sitePoint;
        s.next = nextSite;
        previousSite.next = s;
        nextSite.prev = s;
        return s;
    }
    get turn() {
        if (this.next == null || this.prev == null)
            return 0;
        return Point.getTriangleOrientation(this.prev.point, this.point, this.next.point);
    }
    clone() {
        const s = new CornerSite();
        s.previouisBezierCoefficient = this.previouisBezierCoefficient;
        s.point = this.point;
        return s;
    }
}
//# sourceMappingURL=cornerSite.js.map